import * as yup from 'yup';

export const getLoginPUBForm = yup.object().shape({
  email: yup.string().email('Adresse email est invalide').required('Une adresse email est requise'),
  password: yup
    .string()
    .min(6, 'Votre mot de passe doit contenir au moins 6 caractères')
    .required('Un mot de passe est requis'),
});
